import React from "react";
import "./Badge.css";

const Badge = (props: { status: string }) => {
  let badgeClass = "badge";

  if (props.status === "Processing") {
    badgeClass += " badge-yellow";
  } else if (props.status === "Saved") {
    badgeClass += " badge-green";
  } else if (props.status === "Ready to Save") {
    badgeClass += " badge-green";
  } else if (props.status === "Needs Details") {
    badgeClass += " badge-red";
  } else if (props.status === "Partially Reimbursed") {
    badgeClass += " badge-orange";
  } else if (props.status === "Reimbursed") {
    badgeClass += " badge-blue";
  }

  return <div className={badgeClass}>{props.status}</div>;
};
export default Badge;
